import { render, staticRenderFns } from "./GlobalSpecsFormClassic.vue?vue&type=template&id=1c242a48&"
import script from "./GlobalSpecsFormClassic.vue?vue&type=script&lang=js&"
export * from "./GlobalSpecsFormClassic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports